export const DOMAIN_ERROR_PREFIX = 'logo_maker_error::';
